<template>
  <div class="mb-3">
    <div
      class="flex flex-col mb-2 p-4 border border-solid border-slate-75 dark:border-slate-700 overflow-hidden rounded-md flex-grow shadow-sm dark:bg-slate-900 text-slate-700 dark:text-slate-100 relative"
    >
      <woot-message-editor
        v-model="noteContent"
        class="input--note"
        :placeholder="$t('NOTES.ADD.PLACEHOLDER')"
        :enable-suggestions="false"
          @input="onContentChange"
      />
    </div>
    <div class="flex w-full">
      <woot-button
        color-scheme="dark-blue"
         v-tooltip.right="$t('NOTES.ADD.TITLE')"
        :is-disabled="buttonDisabled"
        @click="onAdd"
      >
        {{ $t('NOTES.ADD.BUTTON') }} (⌘⏎)
      </woot-button>
    </div>
  </div>
</template>

<script>
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import { hasPressedCommandAndEnter } from 'shared/helpers/KeyboardHelpers';
export default {
  components: {
    WootMessageEditor,
  },

  data() {
    return {
      noteContent: '',
    };
  },

  computed: {
    buttonDisabled() {
      return this.noteContent.trim() === '';
    },
  },

  mounted() {
    document.addEventListener('keydown', this.onMetaEnter);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.onMetaEnter);
  },

  methods: {
    onMetaEnter(e) {
      if (hasPressedCommandAndEnter(e)) {
        e.preventDefault();
        this.onAdd();
      }
    },
    onAdd() {
      if (this.noteContent.trim() !== '') {
        this.$emit('add', this.noteContent);
      }
      this.noteContent = '';
      this.$emit('note-content-changed', '');
    },
    onContentChange(value) {
    this.$emit('note-content-changed', this.noteContent);
  },
  },
  
};
</script>

<style lang="scss" scoped>
.input--note {
  &:deep(.ProseMirror-menubar) {
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  padding:0 !important;
  margin: 0 !important;
  width: 100% !important;
  background: inherit;
    z-index: 20;
  }

  &:deep(.ProseMirror-woot-style) {
    overflow-y: auto;
    max-height: 22.5rem;
  }
}
.dark-blue {
  background-color: #40518a;
}
</style>
